import { CultureInfo } from '../culture-info.model';
import { CultureInfoIt } from './it';

/**
 * @ignore
 */
export const CultureInfoItIT: CultureInfo = {
  name: 'it-IT',
  displayName: 'Italian (Italy)',
  iso3LanguageCode: 'ita',
  iso2LanguageCode: 'it',
  ietfLanguageTag: 'it-IT',
  parent: CultureInfoIt
};
